import { render, staticRenderFns } from "./CreateRetailer.vue?vue&type=template&id=268ceedc&"
import script from "./CreateRetailer.js?vue&type=script&lang=js&"
export * from "./CreateRetailer.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports